import { createContext, useContext, useMemo, useState } from "react";

export const defaultLiveCameraShutterSession = {
  active: false,
  disabled: true,
  triggerShutter: () => {},
};

const LiveCameraShutterContext = createContext({
  ...defaultLiveCameraShutterSession,
  setShutterSession: () => {},
});

export function LiveCameraShutterProvider({ children }) {
  const [session, setSession] = useState(defaultLiveCameraShutterSession);

  const value = useMemo(
    () => ({
      active: session.active,
      disabled: session.disabled,
      triggerShutter: session.triggerShutter ?? (() => {}),
      setShutterSession: setSession,
    }),
    [session],
  );

  return (
    <LiveCameraShutterContext.Provider value={value}>
      {children}
    </LiveCameraShutterContext.Provider>
  );
}

export function useLiveCameraShutter() {
  return useContext(LiveCameraShutterContext);
}
